import React from "react";
import StatCard from "components/card/StatCard";
import InventoryTable from "views/admin/inventory/components/InventoryTable";
import { columnsDataComplex } from "views/admin/inventory/variables/InventorycolumnsData";
import InventoryDataComplex from "views/admin/inventory/variables/InventoryDataComplex.json";

export default function Inventory() {
  return (
    <div className="min-h-screen bg-neutral-950 text-gray-100 px-8 pt-8 pb-10 space-y-10">
      {/* 🔹 상단 요약 카드 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
        <StatCard title="MoM Forecast" value="+23%" description="Month-over-month growth" />
        <StatCard title="Earnings Forecast" value="$642.39" description="Expected revenue projection" />
        <StatCard title="Net Income" value="$642.39" description="Current net income" />
        {/* <StatCard title="This Month Cost" value="$642.39" description="Total cost this month" />
        <StatCard title="Sales" value="$574.34" change="+23%" description="Recent performance" />
        <StatCard title="Total Projects" value="2,935" description="Ongoing operations" /> */}
      </div>

      {/* 📦 인벤토리 테이블 */}
      <div className="bg-[#121212] rounded-2xl border border-[#1e1e1e] shadow-lg p-6">
        <h2 className="text-xl font-bold mb-4">Inventory Overview</h2>
        <p className="text-sm text-gray-400 mb-6">
          Manage your stock levels and restock predictions below.
        </p>
        <InventoryTable columnsData={columnsDataComplex} tableData={InventoryDataComplex} />
      </div>
    </div>
  );
}